import React from 'react';
import { object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon, Tooltip } from '@fiverr-private/fit';
import { s_question_circle } from '@fiverr-private/icons';
import { MP_VIEWED_RECURRING_TITLE_EDUCATION_TOOLTIP } from '../../../../../../utils/mixPanelEvents';

import './style.scss';

const RECURRING_ROOT = 'gig_page_perseus.recurring';
const RECURRING_EDUCATION_ROOT = `${RECURRING_ROOT}.eduction`;

const RecurringTitle = (props, { biEvents }) => {

    const onTooltipOpen = () => {
        biEvents.sendMixPanelEvent({
            eventName: MP_VIEWED_RECURRING_TITLE_EDUCATION_TOOLTIP
        });
    };

    return (
        <div className="recurring-title">
            <strong>
                <I18n k={`${RECURRING_ROOT}.title`}/>
            </strong>
            <Tooltip contentClassName="tooltip-content"
                boxContentClassName="tooltip-box-content"
                content={<I18n k={`${RECURRING_EDUCATION_ROOT}.tooltip`}/>}
                onOpen={onTooltipOpen}
                appendToBody={false}>
                <Icon className="education-info-icon">
                    {s_question_circle}
                </Icon>
            </Tooltip>
        </div>
    );
};

RecurringTitle.contextTypes = {
    biEvents: object
};

export default RecurringTitle;
